import { type MemberInfoI } from '@/models/interface/user';

export enum RoleTypeEnum {
  notJunior = 0,
  isJunior = 1
}

/**
 * 使用者方案列舉
 * 0: None
 * 1: 舊方案 member.PointDate > DateTime.Now（點數到期日未過期）且非新訂閱
 * 2: 新訂閱 packageInfo != null（有方案資訊）
 * 3: 定期制 ayceContract != null 且 Ayce != AyceType.None
 * 4: 線上訂閱
 */
export enum UserPlanTypeEnum {
  None = 0,
  OldPlan = 1,
  PackageInfo = 2,
  Ayce = 3,
  Online = 4
}

/**
 * 會員初始化資料
 */
const initialMemberInfo: MemberInfoI = {
  // 官網會員ID
  memberId: 0,
  // 校園Campus會員ID
  userId: null,
  // B2B ID(大部分會員為411)
  customerId: 0,
  realName: '',
  nickName: '',
  sex: 1,
  birthday: null,
  email: null,
  // 大頭貼 (連動校園 Campus)
  photo: null,
  startDate: '',
  // 視訊到期日
  endDate: '',
  // 是否有已預設等級
  hasLevel: false,
  point: 0,
  //學堂到期日
  pointDate: null,
  // 大等級 (preA1 - C2)
  level: 2,
  // 小等級
  levelStep: 1,
  isDemo: false,
  isPay: 0,
  isFreeUser: 0,
  isThirdParty: false,
  // 是否為國中生
  roleType: RoleTypeEnum.notJunior,
  // 是否可提早預約 (VVIP 專屬)
  canReserveEarly: false,
  chatIds: {
    emailCreation: '',
    grammarCheck: '',
    grammarExplanation: '',
    persona: [],
    translation: '',
    aiAssistant: '',
    aiTeacherAssistant: ''
  },
  packageInfo: null,
  contractStartDate: null,
  reserveDemoDate: null,
  themeSelection: [],
  /**
   * 新舊方案切換版本
   * 0: 舊方案
   * 1: 新方案 (2026/04/01 起註冊及簽約的會員)
   */
  switchVersion: 0,
  /**
   * 使用者方案類型
   * 0: None
   * 1: 舊方案 member.PointDate > DateTime.Now（點數到期日未過期）且非新訂閱
   * 2: 新訂閱 packageInfo != null（有方案資訊）
   * 3: 定期制 ayceContract != null 且 Ayce != AyceType.None
   * 4: 線上訂閱
   */
  planType: UserPlanTypeEnum.None,
  reservationRemaining: 0,
  reservationTotal: 0
};

// 各大等級對應數字
const levelsMapping: { [key: string]: number } = {
  PreA1: 0,
  A1: 1,
  A2: 2,
  B1: 3,
  B2: 4,
  C1: 5,
  C2: 6
};

export { initialMemberInfo, levelsMapping };
